import _ from "lodash";
import { ACTIVITIES, COUNTRIES, PARTICIPANTS, SITES } from "@/constants/config";
import { setParticipantName } from "./utils";

function convertDays(minutes = 0) {
  if (minutes < 60) {
    return;
  }
  const d = Math.floor(minutes / 1440); // 60*24
  const convertD = d * 1440;
  const h = Math.floor((minutes - convertD) / 60);
  const m = Math.round(minutes % 60);

  return { d, h, m };
}
function GET_OVERALL_COLLECTION_SERIES(rawData, chosenCountries = [], chosenSites = [], tabName = "", participantList) {
  if (!rawData || chosenCountries.length === 0 || chosenSites.length === 0) {
    return;
  }
  const rawDataTest = rawData;
  const series = {};

  const initData = tabName === PARTICIPANTS ? [] : [{ value: 0 }];
  series["dataset"] = [];
  series["categories"] = [];

  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#7f69d4";
  series["dataset"][0] = {
    seriesname: "Completed",
    color: primaryColor,
    data: initData
  };
  series["dataset"][1] = {
    seriesname: "Missing",
    color: "#cab2d6",
    data: initData
  };
  series["categories"][0] = { category: [] };

  const dataTemp = {};
  const tmpSortData = [];

  if (tabName !== PARTICIPANTS) {
    Object.entries(rawDataTest).forEach(([activityName, itemCountryPerActivity]) => {
      let dataCompleted = 0;
      let dataMissing = 0;

      Object.entries(itemCountryPerActivity).forEach(([countryNamePerActivity, sitesPerCountry]) => {
        Object.entries(sitesPerCountry).forEach(([siteName, siteContent]) => {
          if ((chosenSites.includes("all") || chosenSites.includes(siteName)) && (chosenCountries === "all" || chosenCountries.includes(countryNamePerActivity) || chosenCountries.includes("all"))) {
            if (tabName === ACTIVITIES) {
              dataCompleted += Number(siteContent["nTotalCompleted"]);
              dataMissing += Number(siteContent["nTotalMissing"]);
            } else {
              const element = tabName === COUNTRIES ? countryNamePerActivity : siteName;
              if (dataTemp[element]) {
                if (tabName === PARTICIPANTS) {
                  dataTemp[element].avgHourQueriesClose += Number(siteContent["avgHourQueriesClose"]);
                  dataTemp[element].longestActivity += Number(siteContent["longestActivity"]);
                } else {
                  dataTemp[element].completed += Number(siteContent["nTotalCompleted"]);
                  dataTemp[element].missing += Number(siteContent["nTotalMissing"]);
                }
              } else {
                dataTemp[element] =
                  tabName === PARTICIPANTS
                    ? {
                        avgHourQueriesClose: Number(siteContent["avgHourQueriesClose"]),
                        longestActivity: Number(siteContent["longestActivity"])
                      }
                    : {
                        completed: Number(siteContent["nTotalCompleted"]),
                        missing: Number(siteContent["nTotalMissing"])
                      };
              }
            }
          }
        });
      });
      // if tab === activities, add activities to categories
      if (tabName === ACTIVITIES) {
        tmpSortData.push({
          label: activityName,
          completed: dataCompleted,
          missing: dataMissing
        });
      }
    });
  } else {
    Object.entries(rawDataTest).forEach(([countryName, sitesPerCountry]) => {
      Object.entries(sitesPerCountry).forEach(([siteName, siteContent]) => {
        if ((chosenSites.includes("all") || chosenSites.includes(siteName)) && (chosenCountries === "all" || chosenCountries.includes(countryName))) {
          Object.entries(siteContent).forEach(([participantId, participantContent]) => {
            const element = participantId;
            if (dataTemp[element]) {
              if (tabName === PARTICIPANTS) {
                dataTemp[element].avgHourQueriesClose += Number(participantContent["avgHourQueriesClose"]);
                dataTemp[element].longestActivity += Number(participantContent["longestActivity"]);
              } else {
                dataTemp[element].completed += Number(participantContent["nTotalCompleted"]);
                dataTemp[element].missing += Number(participantContent["nTotalMissing"]);
              }
            } else {
              dataTemp[element] =
                tabName === PARTICIPANTS
                  ? {
                      avgHourQueriesClose: Number(participantContent["avgHourQueriesClose"]),
                      longestActivity: Number(participantContent["longestActivity"])
                    }
                  : {
                      completed: Number(participantContent["nTotalCompleted"]),
                      missing: Number(participantContent["nTotalMissing"])
                    };
            }
          });
        }
      });
    });
  }
  // set data into series for tab activities
  if (tabName === ACTIVITIES) {
    const sortedData = _.orderBy(tmpSortData, ["completed", "label"], ["desc", "asc"]);

    const categoriesLabel = sortedData.map(item => ({ label: item.label }));
    const completedData = sortedData.map(item => (item.completed != 0 ? { value: item.completed } : { showValue: 0 }));
    const missingdata = sortedData.map(item => (item.missing != 0 ? { value: item.missing } : { showValue: 0 }));

    series.categories[0].category = categoriesLabel;
    series.dataset[0].data = completedData;
    series.dataset[1].data = missingdata;
  } else {
    // set data into series for tab other than activities
    Object.keys(dataTemp).map(key => {
      let keyLabel = "";
      if (tabName === PARTICIPANTS) {
        keyLabel = setParticipantName(participantList, key);
      } else {
        keyLabel = key;
      }
      tmpSortData.push({
        label: keyLabel,
        missing: tabName === COUNTRIES || tabName === SITES ? dataTemp[key].missing : dataTemp[key].longestActivity,
        completed: tabName === COUNTRIES || tabName === SITES ? dataTemp[key].completed : dataTemp[key].avgHourQueriesClose
      });
    });

    const sortedData = _.orderBy(tmpSortData, ["completed", "label"], ["desc", "asc"]);
    const categoriesLabel = sortedData.map(item => ({ label: item.label }));
    const completedData = sortedData.map(item => (item.completed != 0 ? { value: item.completed } : { showValue: 0 }));
    const missingdata = sortedData.map(item => (item.missing != 0 ? { value: item.missing } : { showValue: 0 }));

    series.categories[0].category = categoriesLabel;
    series.dataset[0].data = completedData;
    series.dataset[1].data = missingdata;
  }
  let dataIsEmpty = true;
  for (let index = 0; index < series.dataset.length; index++) {
    const d = series.dataset[index];
    const positiveDataFound = d.data.find(s => s.value && s.value > 0);
    if (positiveDataFound) {
      dataIsEmpty = false;
      break;
    }
  }
  if (dataIsEmpty) {
    return;
  }
  return series;
}

function GET_TIME_TO_ACTIVITY_STATUS(rawData, chosenCountries = [], chosenSites = [], tabIndex = 0) {
  const series = {};
  const dataEntryCompleted = [];
  const dataApproved = [];
  const dataVerified = [];
  const dataSignedOff = [];
  const labels = [];

  const tabIndexActivities = {};
  const tabIndexCountries = {};
  const tabIndexSite = {};

  series["dataset"] = [];
  series["categories"] = [];

  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#7f69d4";
  series["dataset"][0] = {
    seriesname: "Entry Completed",
    color: primaryColor,
    data: []
  };
  series["dataset"][1] = { seriesname: "Approved", color: "#cab2d6", data: [] };
  series["dataset"][2] = { seriesname: "Verified", color: "#a6cee3", data: [] };
  series["dataset"][3] = {
    seriesname: "Signed Off",
    color: "#fb9a99",
    data: []
  };
  series["categories"][0] = { category: [] };

  // Case 0 : Show by activities
  // Case 1 : Show by countries
  // Case 2 : Show by sites

  for (const countryName in rawData) {
    const countryData = rawData[countryName];

    if (chosenCountries === "all" || (Array.isArray(chosenCountries) && chosenCountries.length < 1)) {
      for (const siteName in countryData) {
        if (chosenSites[0] === "all") {
          const collection = countryData[siteName]["time_to_activity_status"];

          for (let i = 0; i < collection.length; i++) {
            const activityName = collection[i][0];
            const entryCompleted = collection[i][1];
            const approved = collection[i][2];
            const verified = collection[i][3];
            const signedOff = collection[i][4];

            switch (tabIndex) {
              case 0: {
                if (activityName in tabIndexActivities) {
                  tabIndexActivities[activityName] = {
                    entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                    approved: tabIndexActivities[activityName].approved + approved,
                    verified: tabIndexActivities[activityName].verified + verified,
                    signedOff: tabIndexActivities[activityName].signedOff + signedOff
                  };
                } else {
                  tabIndexActivities[activityName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                  tabIndexActivities[activityName] = {
                    entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                    approved: tabIndexActivities[activityName].approved + approved,
                    verified: tabIndexActivities[activityName].verified + verified,
                    signedOff: tabIndexActivities[activityName].signedOff + signedOff
                  };
                }
                break;
              }
              case 1: {
                if (countryName in tabIndexCountries) {
                  tabIndexCountries[countryName] = {
                    entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                    approved: tabIndexCountries[countryName].approved + approved,
                    verified: tabIndexCountries[countryName].verified + verified,
                    signedOff: tabIndexCountries[countryName].signedOff + signedOff
                  };
                } else {
                  tabIndexCountries[countryName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                  tabIndexCountries[countryName] = {
                    entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                    approved: tabIndexCountries[countryName].approved + approved,
                    verified: tabIndexCountries[countryName].verified + verified,
                    signedOff: tabIndexCountries[countryName].signedOff + signedOff
                  };
                }
                break;
              }
              case 2: {
                if (siteName in tabIndexSite) {
                  tabIndexSite[siteName] = {
                    entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                    approved: tabIndexSite[siteName].approved + approved,
                    verified: tabIndexSite[siteName].verified + verified,
                    signedOff: tabIndexSite[siteName].signedOff + signedOff
                  };
                } else {
                  tabIndexSite[siteName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                  tabIndexSite[siteName] = {
                    entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                    approved: tabIndexSite[siteName].approved + approved,
                    verified: tabIndexSite[siteName].verified + verified,
                    signedOff: tabIndexSite[siteName].signedOff + signedOff
                  };
                }
                break;
              }
              default:
                break;
            }
          }
        } else {
          if (chosenSites.includes(siteName)) {
            const collection = countryData[siteName]["time_to_activity_status"];
            for (let i = 0; i < collection.length; i++) {
              const activityName = collection[i][0];
              const entryCompleted = collection[i][1];
              const approved = collection[i][2];
              const verified = collection[i][3];
              const signedOff = collection[i][4];

              switch (tabIndex) {
                case 0: {
                  if (activityName in tabIndexActivities) {
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                      approved: tabIndexActivities[activityName].approved + approved,
                      verified: tabIndexActivities[activityName].verified + verified,
                      signedOff: tabIndexActivities[activityName].signedOff + signedOff
                    };
                  } else {
                    tabIndexActivities[activityName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                      approved: tabIndexActivities[activityName].approved + approved,
                      verified: tabIndexActivities[activityName].verified + verified,
                      signedOff: tabIndexActivities[activityName].signedOff + signedOff
                    };
                  }
                  break;
                }
                case 1: {
                  if (countryName in tabIndexCountries) {
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                      approved: tabIndexCountries[countryName].approved + approved,
                      verified: tabIndexCountries[countryName].verified + verified,
                      signedOff: tabIndexCountries[countryName].signedOff + signedOff
                    };
                  } else {
                    tabIndexCountries[countryName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                      approved: tabIndexCountries[countryName].approved + approved,
                      verified: tabIndexCountries[countryName].verified + verified,
                      signedOff: tabIndexCountries[countryName].signedOff + signedOff
                    };
                  }
                  break;
                }
                case 2: {
                  if (siteName in tabIndexSite) {
                    tabIndexSite[siteName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                      approved: tabIndexSite[siteName].approved + approved,
                      verified: tabIndexSite[siteName].verified + verified,
                      signedOff: tabIndexSite[siteName].signedOff + signedOff
                    };
                  } else {
                    tabIndexSite[siteName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexSite[siteName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                      approved: tabIndexSite[siteName].approved + approved,
                      verified: tabIndexSite[siteName].verified + verified,
                      signedOff: tabIndexSite[siteName].signedOff + signedOff
                    };
                  }
                  break;
                }
                default:
                  break;
              }
            }
          }
        }
      }
    } else {
      if (chosenCountries.includes(countryName)) {
        const countryData = rawData[countryName];
        for (const siteName in countryData) {
          if (chosenSites[0] === "all") {
            const collection = countryData[siteName]["time_to_activity_status"];

            for (let i = 0; i < collection.length; i++) {
              const activityName = collection[i][0];
              const entryCompleted = collection[i][1];
              const approved = collection[i][2];
              const verified = collection[i][3];
              const signedOff = collection[i][4];

              switch (tabIndex) {
                case 0: {
                  if (activityName in tabIndexActivities) {
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                      approved: tabIndexActivities[activityName].approved + approved,
                      verified: tabIndexActivities[activityName].verified + verified,
                      signedOff: tabIndexActivities[activityName].signedOff + signedOff
                    };
                  } else {
                    tabIndexActivities[activityName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                      approved: tabIndexActivities[activityName].approved + approved,
                      verified: tabIndexActivities[activityName].verified + verified,
                      signedOff: tabIndexActivities[activityName].signedOff + signedOff
                    };
                  }
                  break;
                }
                case 1: {
                  if (countryName in tabIndexCountries) {
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                      approved: tabIndexCountries[countryName].approved + approved,
                      verified: tabIndexCountries[countryName].verified + verified,
                      signedOff: tabIndexCountries[countryName].signedOff + signedOff
                    };
                  } else {
                    tabIndexCountries[countryName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                      approved: tabIndexCountries[countryName].approved + approved,
                      verified: tabIndexCountries[countryName].verified + verified,
                      signedOff: tabIndexCountries[countryName].signedOff + signedOff
                    };
                  }
                  break;
                }
                case 2: {
                  if (siteName in tabIndexSite) {
                    tabIndexSite[siteName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                      approved: tabIndexSite[siteName].approved + approved,
                      verified: tabIndexSite[siteName].verified + verified,
                      signedOff: tabIndexSite[siteName].signedOff + signedOff
                    };
                  } else {
                    tabIndexSite[siteName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexSite[siteName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                      approved: tabIndexSite[siteName].approved + approved,
                      verified: tabIndexSite[siteName].verified + verified,
                      signedOff: tabIndexSite[siteName].signedOff + signedOff
                    };
                  }
                  break;
                }
                default:
                  break;
              }
            }
          } else {
            if (chosenSites.includes(siteName)) {
              const collection = countryData[siteName]["time_to_activity_status"];
              for (let i = 0; i < collection.length; i++) {
                const activityName = collection[i][0];
                const entryCompleted = collection[i][1];
                const approved = collection[i][2];
                const verified = collection[i][3];
                const signedOff = collection[i][4];

                switch (tabIndex) {
                  case 0: {
                    if (activityName in tabIndexActivities) {
                      tabIndexActivities[activityName] = {
                        entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                        approved: tabIndexActivities[activityName].approved + approved,
                        verified: tabIndexActivities[activityName].verified + verified,
                        signedOff: tabIndexActivities[activityName].signedOff + signedOff
                      };
                    } else {
                      tabIndexActivities[activityName] = {
                        entryCompleted: 0,
                        approved: 0,
                        verified: 0,
                        signedOff: 0
                      };
                      tabIndexActivities[activityName] = {
                        entryCompleted: tabIndexActivities[activityName].entryCompleted + entryCompleted,
                        approved: tabIndexActivities[activityName].approved + approved,
                        verified: tabIndexActivities[activityName].verified + verified,
                        signedOff: tabIndexActivities[activityName].signedOff + signedOff
                      };
                    }
                    break;
                  }
                  case 1: {
                    if (countryName in tabIndexCountries) {
                      tabIndexCountries[countryName] = {
                        entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                        approved: tabIndexCountries[countryName].approved + approved,
                        verified: tabIndexCountries[countryName].verified + verified,
                        signedOff: tabIndexCountries[countryName].signedOff + signedOff
                      };
                    } else {
                      tabIndexCountries[countryName] = {
                        entryCompleted: 0,
                        approved: 0,
                        verified: 0,
                        signedOff: 0
                      };
                      tabIndexCountries[countryName] = {
                        entryCompleted: tabIndexCountries[countryName].entryCompleted + entryCompleted,
                        approved: tabIndexCountries[countryName].approved + approved,
                        verified: tabIndexCountries[countryName].verified + verified,
                        signedOff: tabIndexCountries[countryName].signedOff + signedOff
                      };
                    }
                    break;
                  }
                  case 2: {
                    if (siteName in tabIndexSite) {
                      tabIndexSite[siteName] = {
                        entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                        approved: tabIndexSite[siteName].approved + approved,
                        verified: tabIndexSite[siteName].verified + verified,
                        signedOff: tabIndexSite[siteName].signedOff + signedOff
                      };
                    } else {
                      tabIndexSite[siteName] = {
                        entryCompleted: 0,
                        approved: 0,
                        verified: 0,
                        signedOff: 0
                      };
                      tabIndexSite[siteName] = {
                        entryCompleted: tabIndexSite[siteName].entryCompleted + entryCompleted,
                        approved: tabIndexSite[siteName].approved + approved,
                        verified: tabIndexSite[siteName].verified + verified,
                        signedOff: tabIndexSite[siteName].signedOff + signedOff
                      };
                    }
                    break;
                  }
                  default:
                    break;
                }
              }
            }
          }
        }
      }
    }
  }

  switch (tabIndex) {
    case 0: {
      for (const item in tabIndexActivities) {
        labels.push(item);
        dataEntryCompleted.push(tabIndexActivities[item].entryCompleted);
        dataApproved.push(tabIndexActivities[item].approved);
        dataVerified.push(tabIndexActivities[item].verified);
        dataSignedOff.push(tabIndexActivities[item].signedOff);
      }
      break;
    }
    case 1: {
      for (const item in tabIndexCountries) {
        labels.push(item);
        dataEntryCompleted.push(tabIndexCountries[item].entryCompleted);
        dataApproved.push(tabIndexCountries[item].approved);
        dataVerified.push(tabIndexCountries[item].verified);
        dataSignedOff.push(tabIndexCountries[item].signedOff);
      }
      break;
    }
    case 2: {
      for (const item in tabIndexSite) {
        labels.push(item);
        dataEntryCompleted.push(tabIndexSite[item].entryCompleted);
        dataApproved.push(tabIndexSite[item].approved);
        dataVerified.push(tabIndexSite[item].verified);
        dataSignedOff.push(tabIndexSite[item].signedOff);
      }
    }
  }

  const lenghtData = dataEntryCompleted.length;

  for (let i = 0; i < lenghtData; i++) {
    for (let j = 0; j < lenghtData; j++) {
      if (dataEntryCompleted[j] < dataEntryCompleted[j + 1]) {
        const currentEntryCompleted = dataEntryCompleted[j];
        const currentApproved = dataApproved[j];
        const currentVerified = dataVerified[j];
        const currentSignedOff = dataSignedOff[j];
        const currentLabel = labels[j];

        dataEntryCompleted[j] = dataEntryCompleted[j + 1];
        dataEntryCompleted[j + 1] = currentEntryCompleted;

        dataApproved[j] = dataApproved[j + 1];
        dataApproved[j + 1] = currentApproved;

        dataVerified[j] = dataVerified[j + 1];
        dataVerified[j + 1] = currentVerified;

        dataSignedOff[j] = dataSignedOff[j + 1];
        dataSignedOff[j + 1] = currentSignedOff;

        labels[j] = labels[j + 1];
        labels[j + 1] = currentLabel;
      }
    }
  }

  for (let i = 0; i < lenghtData; i++) {
    const payloadLabel = {
      label: labels[i]
    };
    const payloadEntryCompleted = {
      value: dataEntryCompleted[i]
    };
    const payloadApproved = {
      value: dataApproved[i]
    };
    const payloadVerified = {
      value: dataVerified[i]
    };
    const payloadSignedOff = {
      value: dataSignedOff[i]
    };

    series["dataset"][0].data.push(payloadEntryCompleted);
    series["dataset"][1].data.push(payloadApproved);
    series["dataset"][2].data.push(payloadVerified);
    series["dataset"][3].data.push(payloadSignedOff);
    series["categories"][0].category.push(payloadLabel);
  }

  return series;
}

function GET_QUERIES_AVERAGE(rawData, chosenCountries = [], chosenSites = []) {
  let response = {};

  let queryOpen = 0;
  let queryRespond = 0;
  let queryClosed = 0;

  const listSite = new Set();

  const PREFIX_QUERY_OPEN = "n_queries_open";
  const PREFIX_QUERY_RESPONSE = "n_queries_respond";
  const PREFIX_QUERY_CLOSE = "n_queries_closed";

  for (const countryName in rawData) {
    const countryData = rawData[countryName];
    for (const siteName in countryData) {
      const siteData = countryData[siteName];

      // Iterate the bucket days range
      for (const dayRange in siteData) {
        const rangedata = siteData[dayRange];

        // Iterate activities
        for (const activityName in rangedata) {
          const activityData = rangedata[activityName];

          if (chosenCountries === "all" || (Array.isArray(chosenCountries) && chosenCountries.length < 1)) {
            if (chosenSites[0] === "all") {
              queryOpen += activityData[PREFIX_QUERY_OPEN];
              queryRespond += activityData[PREFIX_QUERY_RESPONSE];
              queryClosed += activityData[PREFIX_QUERY_CLOSE];

              listSite.add(siteName);
            } else {
              if (chosenSites.includes(siteName)) {
                queryOpen += activityData[PREFIX_QUERY_OPEN];
                queryRespond += activityData[PREFIX_QUERY_RESPONSE];
                queryClosed += activityData[PREFIX_QUERY_CLOSE];

                listSite.add(siteName);
              }
            }
          } else {
            if (chosenSites[0] === "all") {
              queryOpen += activityData[PREFIX_QUERY_OPEN];
              queryRespond += activityData[PREFIX_QUERY_RESPONSE];
              queryClosed += activityData[PREFIX_QUERY_CLOSE];

              listSite.add(siteName);
            } else {
              if (chosenSites.includes(siteName)) {
                queryOpen += activityData[PREFIX_QUERY_OPEN];
                queryRespond += activityData[PREFIX_QUERY_RESPONSE];
                queryClosed += activityData[PREFIX_QUERY_CLOSE];

                listSite.add(siteName);
              }
            }
          }
        }
      }
    }
  }

  response = {
    open: Number((queryOpen / listSite.size) * 100).toFixed(0),
    response: Number((queryRespond / listSite.size) * 100).toFixed(0),
    closed: Number((queryClosed / listSite.size) * 100).toFixed(0)
  };

  return response;
}

function GET_TIME_ACTIVITY_STATUS(rawData, chosenCountries = [], chosenSites = [], tabIndex = 0) {
  const series = {};

  const dataEntryCompleted = [];
  const dataApproved = [];
  const dataVerified = [];
  const dataSignedOff = [];
  const labels = [];

  const tabIndexActivities = {};
  const tabIndexCountries = {};
  const tabIndexSite = {};

  series["dataset"] = [];
  series["categories"] = [];

  let primaryColor = document.querySelector(":root").style.getPropertyValue("--study-primary-color");
  primaryColor = primaryColor || "#7f69d4";
  series["dataset"][0] = {
    seriesname: "Entry Completed",
    color: primaryColor,
    data: []
  };
  series["dataset"][1] = { seriesname: "Approved", color: "#cab2d6", data: [] };
  series["dataset"][2] = { seriesname: "Verified", color: "#a6cee3", data: [] };
  series["dataset"][3] = {
    seriesname: "Signed Off",
    color: "#fb9a99",
    data: []
  };
  series["categories"][0] = { category: [] };

  const PREFIX_QUERY_ENTRY_COMPLETED = "n_queries_entry_completed";
  const PREFIX_QUERY_APPROVED = "n_queries_approved";
  const PREFIX_QUERY_VERIFIED = "n_queries_verified";
  const PREFIX_QUERY_SIGNED_OFF = "n_queries_signed_off";

  // Iterate the countries
  for (const countryName in rawData) {
    const countryData = rawData[countryName];

    // Iterate the sites
    for (const siteName in countryData) {
      const siteData = countryData[siteName];

      // Iterate the activity
      for (const activityName in siteData) {
        const activityData = siteData[activityName];

        if (chosenCountries === "all" || (Array.isArray(chosenCountries) && chosenCountries.length < 1)) {
          if (chosenSites[0] === "all") {
            switch (tabIndex) {
              case 0: {
                // Get data by activities
                if (activityName in tabIndexActivities) {
                  tabIndexActivities[activityName] = {
                    entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                    approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                    verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                    signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                  };
                } else {
                  tabIndexActivities[activityName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                  tabIndexActivities[activityName] = {
                    entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                    approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                    verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                    signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                  };
                }
                break;
              }
              case 1: {
                // Get data by countries
                if (countryName in tabIndexCountries) {
                  tabIndexCountries[countryName] = {
                    entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                    approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                    verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                    signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                  };
                } else {
                  tabIndexCountries[countryName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                  tabIndexCountries[countryName] = {
                    entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                    approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                    verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                    signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                  };
                }
                break;
              }
              case 2: {
                // Get data by sites
                if (siteName in tabIndexSite) {
                  tabIndexSite[countryName] = {
                    entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                    approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                    verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                    signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                  };
                } else {
                  tabIndexSite[siteName] = {
                    entryCompleted: 0,
                    approved: 0,
                    verified: 0,
                    signedOff: 0
                  };
                  tabIndexSite[siteName] = {
                    entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                    approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                    verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                    signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                  };
                }
                break;
              }
              default:
                break;
            }
          } else {
            if (chosenSites.includes(siteName)) {
              switch (tabIndex) {
                case 0: {
                  // Get data by activities
                  if (activityName in tabIndexActivities) {
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  } else {
                    tabIndexActivities[activityName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  }
                  break;
                }
                case 1: {
                  // Get data by countries
                  if (countryName in tabIndexCountries) {
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  } else {
                    tabIndexCountries[countryName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  }
                  break;
                }
                case 2: {
                  // Get data by sites
                  if (siteName in tabIndexSite) {
                    tabIndexSite[countryName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  } else {
                    tabIndexSite[siteName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexSite[siteName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  }
                  break;
                }
                default:
                  break;
              }
            }
          }
        } else {
          if (chosenCountries.includes(countryName)) {
            if (chosenSites[0] === "all") {
              switch (tabIndex) {
                case 0: {
                  // Get data by activities
                  if (activityName in tabIndexActivities) {
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  } else {
                    tabIndexActivities[activityName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexActivities[activityName] = {
                      entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  }
                  break;
                }
                case 1: {
                  // Get data by countries
                  if (countryName in tabIndexCountries) {
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  } else {
                    tabIndexCountries[countryName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexCountries[countryName] = {
                      entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  }
                  break;
                }
                case 2: {
                  // Get data by sites
                  if (siteName in tabIndexSite) {
                    tabIndexSite[countryName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  } else {
                    tabIndexSite[siteName] = {
                      entryCompleted: 0,
                      approved: 0,
                      verified: 0,
                      signedOff: 0
                    };
                    tabIndexSite[siteName] = {
                      entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                      approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                      verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                      signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                    };
                  }
                  break;
                }
                default:
                  break;
              }
            } else {
              if (chosenSites.includes(siteName)) {
                switch (tabIndex) {
                  case 0: {
                    // Get data by activities
                    if (activityName in tabIndexActivities) {
                      tabIndexActivities[activityName] = {
                        entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                        approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                        verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                        signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                      };
                    } else {
                      tabIndexActivities[activityName] = {
                        entryCompleted: 0,
                        approved: 0,
                        verified: 0,
                        signedOff: 0
                      };
                      tabIndexActivities[activityName] = {
                        entryCompleted: tabIndexActivities[activityName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                        approved: tabIndexActivities[activityName].approved + activityData[PREFIX_QUERY_APPROVED],
                        verified: tabIndexActivities[activityName].verified + activityData[PREFIX_QUERY_VERIFIED],
                        signedOff: tabIndexActivities[activityName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                      };
                    }
                    break;
                  }
                  case 1: {
                    // Get data by countries
                    if (countryName in tabIndexCountries) {
                      tabIndexCountries[countryName] = {
                        entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                        approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                        verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                        signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                      };
                    } else {
                      tabIndexCountries[countryName] = {
                        entryCompleted: 0,
                        approved: 0,
                        verified: 0,
                        signedOff: 0
                      };
                      tabIndexCountries[countryName] = {
                        entryCompleted: tabIndexCountries[countryName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                        approved: tabIndexCountries[countryName].approved + activityData[PREFIX_QUERY_APPROVED],
                        verified: tabIndexCountries[countryName].verified + activityData[PREFIX_QUERY_VERIFIED],
                        signedOff: tabIndexCountries[countryName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                      };
                    }
                    break;
                  }
                  case 2: {
                    // Get data by sites
                    if (siteName in tabIndexSite) {
                      tabIndexSite[countryName] = {
                        entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                        approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                        verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                        signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                      };
                    } else {
                      tabIndexSite[siteName] = {
                        entryCompleted: 0,
                        approved: 0,
                        verified: 0,
                        signedOff: 0
                      };
                      tabIndexSite[siteName] = {
                        entryCompleted: tabIndexSite[siteName].entryCompleted + activityData[PREFIX_QUERY_ENTRY_COMPLETED],
                        approved: tabIndexSite[siteName].approved + activityData[PREFIX_QUERY_APPROVED],
                        verified: tabIndexSite[siteName].verified + activityData[PREFIX_QUERY_VERIFIED],
                        signedOff: tabIndexSite[siteName].signedOff + activityData[PREFIX_QUERY_SIGNED_OFF]
                      };
                    }
                    break;
                  }
                  default:
                    break;
                }
              }
            }
          }
        }
      }
    }
  }

  // Sort the highest values
  switch (tabIndex) {
    case 0: {
      for (const item in tabIndexActivities) {
        labels.push(item);

        const comppleteDay = convertDays(tabIndexActivities[item].entryCompleted);
        const approveDay = convertDays(tabIndexActivities[item].entryCompleted);
        const verifiedDay = convertDays(tabIndexActivities[item].entryCompleted);
        const signOffDay = convertDays(tabIndexActivities[item].entryCompleted);

        dataEntryCompleted.push(comppleteDay.d);
        dataApproved.push(approveDay.d);
        dataVerified.push(verifiedDay.d);
        dataSignedOff.push(signOffDay.d);
      }
      break;
    }
    case 1: {
      for (const item in tabIndexCountries) {
        labels.push(item);

        const comppleteDay = convertDays(tabIndexCountries[item].entryCompleted);
        const approveDay = convertDays(tabIndexCountries[item].entryCompleted);
        const verifiedDay = convertDays(tabIndexCountries[item].entryCompleted);
        const signOffDay = convertDays(tabIndexCountries[item].entryCompleted);

        dataEntryCompleted.push(comppleteDay.d);
        dataApproved.push(approveDay.d);
        dataVerified.push(verifiedDay.d);
        dataSignedOff.push(signOffDay.d);
      }
      break;
    }
    case 2: {
      for (const item in tabIndexSite) {
        labels.push(item);

        const comppleteDay = convertDays(tabIndexSite[item].entryCompleted);
        const approveDay = convertDays(tabIndexSite[item].entryCompleted);
        const verifiedDay = convertDays(tabIndexSite[item].entryCompleted);
        const signOffDay = convertDays(tabIndexSite[item].entryCompleted);

        dataEntryCompleted.push(comppleteDay.d);
        dataApproved.push(approveDay.d);
        dataVerified.push(verifiedDay.d);
        dataSignedOff.push(signOffDay.d);
      }
    }
  }

  const lenghtData = dataEntryCompleted.length;

  for (let i = 0; i < lenghtData; i++) {
    for (let j = 0; j < lenghtData; j++) {
      if (dataEntryCompleted[j] < dataEntryCompleted[j + 1]) {
        const currentEntryCompleted = dataEntryCompleted[j];
        const currentApproved = dataApproved[j];
        const currentVerified = dataVerified[j];
        const currentSignedOff = dataSignedOff[j];
        const currentLabel = labels[j];

        dataEntryCompleted[j] = dataEntryCompleted[j + 1];
        dataEntryCompleted[j + 1] = currentEntryCompleted;

        dataApproved[j] = dataApproved[j + 1];
        dataApproved[j + 1] = currentApproved;

        dataVerified[j] = dataVerified[j + 1];
        dataVerified[j + 1] = currentVerified;

        dataSignedOff[j] = dataSignedOff[j + 1];
        dataSignedOff[j + 1] = currentSignedOff;

        labels[j] = labels[j + 1];
        labels[j + 1] = currentLabel;
      }
    }
  }

  for (let i = 0; i < lenghtData; i++) {
    const payloadLabel = {
      label: labels[i]
    };
    const payloadEntryCompleted = {
      value: dataEntryCompleted[i]
    };
    const payloadApproved = {
      value: dataApproved[i]
    };
    const payloadVerified = {
      value: dataVerified[i]
    };
    const payloadSignedOff = {
      value: dataSignedOff[i]
    };

    series["dataset"][0].data.push(payloadEntryCompleted);
    series["dataset"][1].data.push(payloadApproved);
    series["dataset"][2].data.push(payloadVerified);
    series["dataset"][3].data.push(payloadSignedOff);
    series["categories"][0].category.push(payloadLabel);
  }

  return series;
}

function GET_AVERAGE_TIME_STATUS(rawData, chosenCountries = [], chosenSites = []) {
  let response = {};

  let avgEntryCompleted = 0;
  let avgApproved = 0;
  let avgVerified = 0;
  let avgSignedOff = 0;

  let longestEntryCompleted = "";
  let longestApproved = "";
  let longestVerified = "";
  let longestSignedOff = "";

  const listSites = new Set();

  const PREFIX_QUERY_ENTRY_COMPLETED = "n_queries_entry_completed";
  const PREFIX_QUERY_APPROVED = "n_queries_approved";
  const PREFIX_QUERY_VERIFIED = "n_queries_verified";
  const PREFIX_QUERY_SIGNED_OFF = "n_queries_signed_off";

  // Iterate the countries
  for (const countryName in rawData) {
    const countryData = rawData[countryName];

    // Iterate the sites
    for (const siteName in countryData) {
      const siteData = countryData[siteName];

      longestEntryCompleted = Object.keys(siteData).reduce((a, b) => {
        return siteData[a][PREFIX_QUERY_ENTRY_COMPLETED] > siteData[b][PREFIX_QUERY_ENTRY_COMPLETED] ? a : b;
      });

      longestApproved = Object.keys(siteData).reduce((a, b) => {
        return siteData[a][PREFIX_QUERY_APPROVED] > siteData[b][PREFIX_QUERY_APPROVED] ? a : b;
      });

      longestVerified = Object.keys(siteData).reduce((a, b) => {
        return siteData[a][PREFIX_QUERY_VERIFIED] > siteData[b][PREFIX_QUERY_VERIFIED] ? a : b;
      });

      longestSignedOff = Object.keys(siteData).reduce((a, b) => {
        return siteData[a][PREFIX_QUERY_SIGNED_OFF] > siteData[b][PREFIX_QUERY_SIGNED_OFF] ? a : b;
      });

      // Iterate the activity
      for (const activityName in siteData) {
        const activityData = siteData[activityName];

        if (chosenCountries === "all" || (Array.isArray(chosenCountries) && chosenCountries.length < 1)) {
          if (chosenSites[0] === "all") {
            avgEntryCompleted += activityData[PREFIX_QUERY_ENTRY_COMPLETED];
            avgApproved += activityData[PREFIX_QUERY_APPROVED];
            avgVerified += activityData[PREFIX_QUERY_VERIFIED];
            avgSignedOff += activityData[PREFIX_QUERY_SIGNED_OFF];

            listSites.add(siteName);
          } else {
            if (chosenSites.includes(siteName)) {
              avgEntryCompleted += activityData[PREFIX_QUERY_ENTRY_COMPLETED];
              avgApproved += activityData[PREFIX_QUERY_APPROVED];
              avgVerified += activityData[PREFIX_QUERY_VERIFIED];
              avgSignedOff += activityData[PREFIX_QUERY_SIGNED_OFF];

              listSites.add(siteName);
            }
          }
        } else {
          if (chosenSites[0] === "all") {
            avgEntryCompleted += activityData[PREFIX_QUERY_ENTRY_COMPLETED];
            avgApproved += activityData[PREFIX_QUERY_APPROVED];
            avgVerified += activityData[PREFIX_QUERY_VERIFIED];
            avgSignedOff += activityData[PREFIX_QUERY_SIGNED_OFF];

            listSites.add(siteName);
          } else {
            avgEntryCompleted += activityData[PREFIX_QUERY_ENTRY_COMPLETED];
            avgApproved += activityData[PREFIX_QUERY_APPROVED];
            avgVerified += activityData[PREFIX_QUERY_VERIFIED];
            avgSignedOff += activityData[PREFIX_QUERY_SIGNED_OFF];

            listSites.add(siteName);
          }
        }
      }
    }
  }

  avgEntryCompleted = avgEntryCompleted / listSites.size;
  avgApproved = avgApproved / listSites.size;
  avgVerified = avgVerified / listSites.size;
  avgSignedOff = avgSignedOff / listSites.size;

  response = {
    avgEntryCompleted: convertDays(avgEntryCompleted),
    avgApproved: convertDays(avgApproved),
    avgVerified: convertDays(avgVerified),
    avgSignedOff: convertDays(avgSignedOff),
    longestEntryCompleted: longestEntryCompleted,
    longestApproved: longestApproved,
    longestVerified: longestVerified,
    longestSignedOff: longestSignedOff
  };

  return response;
}

export { GET_OVERALL_COLLECTION_SERIES, GET_TIME_TO_ACTIVITY_STATUS, GET_QUERIES_AVERAGE, GET_TIME_ACTIVITY_STATUS, GET_AVERAGE_TIME_STATUS };
